import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { Box, Button, Container, Typography } from "src/UILibrary"

import { useRecoilState } from "recoil"
import { useNavigate } from "react-router-dom"
import { validateField } from "src/modules/validation"
import * as yup from "yup"
import { ShowToast } from "src/states/showToast"
import { AuthenticationService } from "src/openapi"
import { RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import { ShowHeader } from "src/states/showHeader"
import InputTextField from "src/components/atom/InputTextField"
import { ShowProgress } from "src/states/showProgress"

export const EmailConfirm = () => {
  const { t } = useTranslation("translation", { keyPrefix: "password_reset" })

  const navigate = useNavigate()

  const [, setShowHeader] = useRecoilState(ShowHeader)
  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [email, setEmail] = useState<string>("")
  const [emailVerificationMesage, setEmailVerificationMessage] = useState<string>("")

  useEffect(() => {
    setShowHeader(false)
  })

  const validate = async () => {
    try {
      await validateField(
        yup.object().shape({
          email: yup
            .string()
            .required(t("please_input_email"))
            .email(t("please_input_correct_email")),
        }),
        "email",
        email
      )
      setEmailVerificationMessage("")
    } catch (err: any) {
      setEmailVerificationMessage(err.message)
      return false
    }
    return true
  }

  const handleNext = async () => {
    if (!(await validate())) {
      return
    }

    setShowProgress(true)
    AuthenticationService.requestResetPassword({
      email: email,
    })
      .then((res) => {
        setShowProgress(false)
        if (res.status === RESPONSE_CODE.SUCCESS) {
          navigate("/password_reset", { state: { email: email } })
        } else {
          setShowToast({
            show: true,
            text: t("send_confirm_mail_failed"),
            type: SNACKBAR_TYPES.ERROR,
          })
        }
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({
          show: true,
          text: t("send_confirm_mail_failed"),
          type: SNACKBAR_TYPES.ERROR,
        })
      })
  }

  const handlePrev = () => {
    navigate("/signin")
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ display: "flex", flexDirection: "column" }}>
        <Typography.Large sx={{ mt: "100px", color: "text.primary" }}>
          {t("password_reset")}
        </Typography.Large>
        <Container maxWidth="md" sx={{ mx: "auto" }}>
          <Typography.DetailText sx={{ mt: "60px", color: "text.primary", fontWeight: "400" }}>
            {t("password_reset_description_1")}
          </Typography.DetailText>
          <Typography.DetailText sx={{ color: "text.primary", fontWeight: "400" }}>
            {t("password_reset_description_2")}
          </Typography.DetailText>
          <InputTextField
            name={t("email")}
            text={email}
            handleText={setEmail}
            sx={{ mt: "40px" }}
            required
            validationMessage={emailVerificationMesage}
          />
          <Button
            variant="outlined"
            sx={{
              mt: "20px",
              width: "240px",
              borderRadius: 0,
              borderColor: "text.primary",
              py: "16px",
            }}
            onClick={() => handleNext()}
          >
            <Typography.ButtonText sx={{ fontSize: "16px", fontFamily: "Noto Sans JP !important" }}>
              {t("send_confirm_mail")}
            </Typography.ButtonText>
          </Button>
          <Box
            sx={{
              mt: "20px",
              width: "240px",
              p: 0,
              cursor: "pointer",
              display: "flex",
            }}
            onClick={() => handlePrev()}
          >
            <Typography.ExtraSmallText>{"<"}</Typography.ExtraSmallText>
            <Typography.ExtraSmallText sx={{ ml: "10px" }}>
              {t("here_to_signin")}
            </Typography.ExtraSmallText>
          </Box>
        </Container>
      </Container>
    </>
  )
}
